import React from 'react';

const Loader = () => (
    <div className="load_wrap">
        <img src={`./static/images/wms_loading.gif`} alt="loading" />
    </div>
);

export default Loader;
